import { render, staticRenderFns } from "./PopupFooterTwoButtons.vue?vue&type=template&id=f482d60c&scoped=true&"
import script from "./PopupFooterTwoButtons.vue?vue&type=script&lang=js&"
export * from "./PopupFooterTwoButtons.vue?vue&type=script&lang=js&"
import style0 from "./PopupFooterTwoButtons.vue?vue&type=style&index=0&id=f482d60c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f482d60c",
  null
  
)

export default component.exports